import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { AudioProgressBackgroundDirective } from './directives/audio-progress-background.directive';

@Component({
  selector: 'cv-audio-player',
  standalone: true,
  imports: [FormsModule, FormatTimePipe, AudioProgressBackgroundDirective],
  templateUrl: './audio-player.component.html',
  styleUrl: './audio-player.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AudioPlayerComponent {
  @Input({ required: true }) audioSource: string | null = null;
  @Input() isMobile: boolean = false;
  @Output() readonly timeUpdate: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;

  constructor(readonly cdr: ChangeDetectorRef) {}

  togglePlay(): void {
    if (this.audioPlayer.nativeElement.paused) {
      void this.audioPlayer.nativeElement.play();
    } else {
      this.audioPlayer.nativeElement.pause();
    }
  }

  rewind(seconds: number): void {
    this.audioPlayer.nativeElement.currentTime -= seconds;
  }

  forward(seconds: number): void {
    this.audioPlayer.nativeElement.currentTime += seconds;
  }

  onTimeRangeChange(event: Event): void {
    this.audioPlayer.nativeElement.currentTime = Number((event.target as HTMLInputElement).value);
  }

  play(seconds: number = 0): void {
    this.audioPlayer.nativeElement.currentTime = seconds;
    this.timeUpdate.emit(this.audioPlayer.nativeElement.currentTime);
    void this.audioPlayer.nativeElement.play();
  }
}
